/* eslint-disable no-return-assign */
/* eslint-disable react/button-has-type */
import I18n from 'i18n-js';
import React, { useRef } from 'react';
import Button from 'components/Button/Button';
import { navigate } from 'navigation';
import OnboardingPerfilDeConsumo from 'types/models/onboardingPertfilConsumo';
import styles from './onboarding-perfil-consumo-list-row.module.scss';
import stylesDropdown from './onboarding-perfil-consumo-dropdown.module.scss';

interface OnboardingPerfilConsumoListRowProps {
  configuracion: OnboardingPerfilDeConsumo;
  deleteOnChange: CallableFunction;
}

export const OnboardingPerfilConsumoListRow = (props: OnboardingPerfilConsumoListRowProps): JSX.Element => {
  const { configuracion } = props;

  const { t } = I18n;

  const dropdownRefs = useRef<(HTMLElement | null)[]>([]); // Arreglo de referencias para los dropdowns

  const lastTableRowRef = useRef<HTMLTableRowElement | null>(null);

  return (
    <>
      <tr className={styles.mainrow} ref={lastTableRowRef}>
        <td>{configuracion.id}</td>
        <td>{configuracion.perfil_consumidor}</td>
        <td>
          <label className={styles.checkboxTable}>
            <input type="checkbox" defaultChecked={configuracion.curva_consumo} disabled />
          </label>
        </td>
        <td>{configuracion.fecha_actualizacion}</td>

        <td>
          <div className={stylesDropdown.dropdown} ref={(ref) => (dropdownRefs.current[configuracion.id] = ref)}>
            <Button
              className={styles.viewmore_button}
              variant="tertiary"
              type="button"
              onClick={() => {
                navigate(`/tecnic/onboarding/perfil-consumo/${configuracion.id}/edit`);
              }}
              text={t(`PerfilListPage.actions.ver`)}
            />
          </div>
        </td>
      </tr>
    </>
  );
};
